import React from 'react';
import { Modal as AntdModal } from 'antd';
import classNames from 'classnames';
import { useControllableValue } from 'ahooks';
import ModalRender from './modalRender';
import useModal from './useModal';
import confirm from './confirm';
import { jsx as _jsx } from "react/jsx-runtime";
const Modal = props => {
  const {
    defaultOpen,
    open: propOpen,
    onOpenChange: propOnOpenChange,
    children,
    destroyOnClose,
    centered,
    zIndex = 1000,
    mask,
    width,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...renderProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-modal");
  const [open, onOpenChange] = useControllableValue(props, {
    defaultValue: false,
    defaultValuePropName: 'defaultOpen',
    valuePropName: 'open',
    trigger: 'onOpenChange'
  });
  return /*#__PURE__*/_jsx(AntdModal, {
    width: width,
    className: classNames(className, baseClassName),
    style: style,
    open: open,
    mask: mask,
    modalRender: () => /*#__PURE__*/_jsx(ModalRender, {
      ...renderProps,
      onClose: () => onOpenChange(false),
      content: children
    }),
    destroyOnClose: destroyOnClose,
    centered: centered,
    zIndex: zIndex
  });
};
Modal.confirm = confirm;
Modal.useModal = useModal;
Modal.destroyAll = AntdModal.destroyAll;
export default Modal;